import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

const styles = cva('block mb-[0.8rem] items-center ', {
  variants: {
    required: {
      true: 'after:content-["*"] after:ml-0.5 after:text-red-500',
    },
  },
  defaultVariants: {
    required: false,
  },
});

interface Props extends VariantProps<typeof styles> {
  value: string;
  children: React.ReactNode;
  errorMessage?: string;
  labelClasses?: string;
}

const FormLabel = ({
  children,
  value,
  errorMessage,
  required,
  labelClasses,
}: Props) => {
  // Check if error message is long (more than 50 chars) - display below input instead of inline
  const isLongError = errorMessage && errorMessage.length > 50;

  return (
    <div className="block w-full text-[1.5rem]">
      <div className="flex justify-between">
        <span className={styles({ required }) + ' ' + labelClasses}>
          {value}
        </span>
        {!!errorMessage && !isLongError && (
          <span className="text-[1.2rem] text-brand-red">{errorMessage}</span>
        )}
      </div>
      {children}
      {!!errorMessage && isLongError && (
        <p className="mt-[0.8rem] text-[1.2rem] leading-[1.6rem] text-brand-red">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default FormLabel;
